export default __webpack_public_path__ + "static/area_8-4ad5d01c4e13383b8c2ae4c924b79862.jpg";